<template>
  <div
    class="donation-form__qr__wrapper"
    :class="{ 'donation-form__qr__wrapper--active': active }"
  >
    <div class="donation-form__qr__loader-wrapper">
      <div class="donation-form__qr__loader">
        <Loader :loading="true" />
      </div>
      <h3 v-text="texts.createComment.swishChecking" />
    </div>
    <button class="donation-form__qr__toggle" type="button" @click="toggleQR">
      {{ texts.createComment.swishOtherDevice }}
      <span v-text="texts.common.here" />
    </button>
    <div class="donation-form__qr__container">
      <h3 v-text="texts.createComment.swishScanQr" />
      <div ref="svg" v-html="svgData" />
      <h4>{{ texts.createComment.donationPingInfo }}</h4>
    </div>
  </div>
</template>

<script>
  import Loader from "../Loader.vue";
  export default {
    components: {
      Loader,
    },
    data() {
      return {
        active: false,
        texts: lavendlaObituary,
      };
    },
    methods: {
      toggleQR() {
        this.active = true;
      },
    },
    name: "SwishQRLoading",
    props: {
      svgData: {
        required: true,
        type: String,
      },
    },
  };
</script>
